export const AUTHENTICATION_ERROR = 'Authentication Error';
export const CHRONOLOGICAL_NEWEST_FIRST = 'CHRONOLOGICAL_NEWEST_FIRST';
export const EPISODE_ID = 'EPISODE_ID';
export const ERROR = 'ERROR';
export const DEFAULT_LOADING_COUNT = 3;
